import { BackgroundColorLayerTypename, BackgroundGradientLayerTypename, BackgroundImageLayerTypename } from '../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutBuffersRpc';
import { ALIGNMENTS } from 'ContentUtils/constants/Alignments';
import BACKGROUND_IMAGE_SIZE_TYPES from 'ContentUtils/constants/BackgroundImageSizeTypes';
export const ACTION_TOOLBARS = {
  COLUMN: 'COLUMN',
  MODULE: 'MODULE',
  NON_LS_MODULE: 'NON_LS_MODULE',
  ROW: 'ROW',
  TOP_MOST_ROW: 'TOP_MOST_ROW'
};
export const ACTION_TOOLBAR_BUTTONS = {
  CLONE: 'CLONE',
  COLUMN: 'COLUMN',
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  EDIT_LAYOUT: 'EDIT_LAYOUT',
  EDIT_STYLES: 'EDIT_STYLES',
  MAKE_SMART: 'MAKE_SMART',
  MODULE: 'MODULE',
  MOVE: 'MOVE',
  ROW: 'ROW'
};
export const ACTION_TOOLBAR_BUTTON_IMAGE_HEIGHT = 18;
export const ACTION_TOOLBAR_BUTTON_SIZE = 32;
export const ACTION_TOOLBAR_PADDING = 5;
export const CURSORS = {
  DEFAULT: 'DEFAULT',
  GRAB: 'GRAB',
  MOVE: 'MOVE',
  POINTER: 'POINTER'
};
export const DOT = '·';

// Drag preview icon
export const DRAG_ICON_BACKGROUND_COLOR = '#00a4bd'; // CALYPSO - fill-accent-blue-default
export const DRAG_ICON_INVALID_BACKGROUND_COLOR = '#cbd6e2'; // BATTLESHIP - fill-tertiary-pressed
export const DRAG_ICON_INVALID_ICON_OPACITY = 0.75;
export const LINE_FEED = String.fromCharCode(10);

// Drop target colors
export const DROP_TARGET_MAIN_COLOR = '#00a4bd'; // CALYPSO - fill-accent-blue-default
export const DROP_TARGET_OUTLINE_COLOR = '#ffffff'; // OLAF - fill-surface-default
export const DROP_TARGET_DISABLED_COLOR = '#eaf0f6'; // KOALA - fill-primary-disabled

export const FONTS_TO_LOAD = ['body-100', 'heading-25'];
export const BACKGROUND_IMAGE_DEFAULTS = {
  imageUrl: '',
  backgroundSize: BACKGROUND_IMAGE_SIZE_TYPES.cover,
  backgroundPosition: ALIGNMENTS.MIDDLE_CENTER
  // colorOverlay: { hex: '#AABBCC', alpha: 0.5, },
};
export const GRIDS_BACKGROUND_IMAGE_SIZE_TYPES = ['COVER', 'CONTAIN', 'AUTO'];
export const BG_RGBA_COLOR_DEFAULT = {
  red: 255,
  green: 255,
  blue: 255,
  alpha: 1
};
export const BACKGROUND_COLOR_DEFAULTS = {
  __typename: BackgroundColorLayerTypename,
  type: 'COLOR',
  color: BG_RGBA_COLOR_DEFAULT
};
export const GRIDS_BACKGROUND_IMAGE_DEFAULTS = {
  __typename: BackgroundImageLayerTypename,
  type: 'IMAGE',
  imageUrl: '',
  backgroundSize: 'COVER',
  backgroundPosition: 'MIDDLE_CENTER'
};
export const GRIDS_BACKGROUND_GRADIENT_DEFAULTS = {
  __typename: BackgroundGradientLayerTypename,
  type: 'GRADIENT',
  sideOrCorner: {
    verticalSide: 'BOTTOM'
  },
  colors: [{
    red: 203,
    green: 214,
    blue: 226,
    alpha: 1
  }, {
    red: 234,
    green: 240,
    blue: 246,
    alpha: 1
  }]
};
export const RADIO = 'RADIO';
export const SELECT = 'SELECT';